const mockData = {
  learningGoal: 'advance_career',
  editMode: 'static',
  visibilityLearningGoal: 'private',
};

export default mockData;
